// Location content — edit hours, phones and ordering links here.
const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const LOCATIONS = [
  {
    slug: "teadm-plus-falls-church",
    brand: "teadm",
    name: "TeaDM Plus",
    city: "Falls Church",
    area: "Seven Corners",
    street: "6779 Wilson Blvd",
    state: "VA",
    zip: "22044",
    phone: "(703) 477-6807",
    hours: [
      { days: "Mon – Sat", time: "7:00 AM – 12:00 AM" },
      { days: "Sunday", time: "7:00 AM – 9:00 PM" },
    ],
    hoursSpec: [
      { days: WEEKDAYS, opens: "07:00", closes: "23:59" },
      { days: ["Sunday"], opens: "07:00", closes: "21:00" },
    ],
    orderUrl: "https://teadm.toast.site/order/teadmplus",
    coords: [38.874193, -77.1548591],
    image: "/img/cup-milk-tea.webp",
    color: "#FF2E63",
    info: "The early bird of the family — doors open at 7 AM every day. New on the menu here: TeaDM Popcorn Chicken and Eggspresso Over Ice.",
    seoTitle: "TeaDM Plus — Bubble Tea & Boba in Falls Church, VA",
    seoDesc: "Boba tea, Vietnamese coffee and seasalt drinks at TeaDM Plus, 6779 Wilson Blvd, Seven Corners, Falls Church, VA. Open 7 AM daily. Order online for pickup.",
  },
  {
    slug: "teadm-fairfax",
    brand: "teadm",
    name: "TeaDM Fairfax",
    city: "Fairfax",
    area: "Fairfax Blvd",
    street: "9416 Fairfax Blvd",
    state: "VA",
    zip: "22031",
    phone: "(571) 488-4089",
    hours: [
      { days: "Mon – Sat", time: "9:00 AM – 12:00 AM" },
      { days: "Sunday", time: "9:00 AM – 9:00 PM" },
    ],
    hoursSpec: [
      { days: WEEKDAYS, opens: "09:00", closes: "23:59" },
      { days: ["Sunday"], opens: "09:00", closes: "21:00" },
    ],
    orderUrl: "https://teadm.toast.site/order/teadm-fairfax",
    coords: [38.8651081, -77.2707316],
    image: "/img/cup-cocoa.webp",
    color: "#FF7A00",
    info: "On Fairfax Blvd and open until midnight Monday through Saturday — made for late-night study sessions and after-dinner boba runs.",
    seoTitle: "TeaDM Fairfax — Bubble Tea & Boba in Fairfax, VA",
    seoDesc: "Bubble tea, milk tea and Vietnamese coffee at TeaDM Fairfax, 9416 Fairfax Blvd, Fairfax, VA. Open until midnight Mon–Sat. Order online with Toast.",
  },
  {
    slug: "teadm-mini-vienna",
    brand: "teadm",
    name: "TeaDM Mini",
    city: "Vienna",
    area: "Maple Ave",
    street: "142 Maple Ave W",
    state: "VA",
    zip: "22180",
    phone: "(571) 488-4019",
    hours: [{ days: "Mon – Sun", time: "9:00 AM – 10:00 PM" }],
    hoursSpec: [{ days: [...WEEKDAYS, "Sunday"], opens: "09:00", closes: "22:00" }],
    orderUrl: "https://teadm.toast.site/order/teadmmini",
    coords: [38.900011, -77.266157],
    image: "/img/cup-green-mango.webp",
    color: "#2E9E4F",
    info: "Small shop, full menu. Our Mini on Maple Ave pours the same matcha, milk teas and seasalt coffees seven days a week.",
    seoTitle: "TeaDM Mini — Matcha & Bubble Tea in Vienna, VA",
    seoDesc: "Matcha, milk tea and boba at TeaDM Mini, 142 Maple Ave W, Vienna, VA. Open 9 AM – 10 PM every day. Order online for pickup.",
  },
  {
    slug: "teadm-sterling",
    brand: "teadm",
    name: "TeaDM Sterling",
    city: "Sterling",
    area: "Harry Byrd Hwy",
    street: "46515 Harry Byrd Hwy, Suite 190",
    state: "VA",
    zip: "20164",
    phone: "(571) 497-1141",
    hours: [
      { days: "Mon – Sat", time: "9:00 AM – 12:00 AM" },
      { days: "Sunday", time: "9:00 AM – 9:00 PM" },
    ],
    hoursSpec: [
      { days: WEEKDAYS, opens: "09:00", closes: "23:59" },
      { days: ["Sunday"], opens: "09:00", closes: "21:00" },
    ],
    orderUrl: "https://teadm.toast.site/order/teadm-sterling-46515-harry-byrd-hwy",
    coords: [39.0152267, -77.3721518],
    image: "/img/cup-sunrise.webp",
    color: "#7B5CE6",
    info: "Our Loudoun County home, listed on Google as TeaDM Street Food Corner. Open until midnight Monday through Saturday.",
    seoTitle: "TeaDM Sterling — Bubble Tea & Boba in Sterling, VA",
    seoDesc: "Boba tea and Vietnamese coffee at TeaDM Sterling, 46515 Harry Byrd Hwy Suite 190, Sterling, VA. Open until midnight Mon–Sat. Order online.",
  },
];

export const TEADM_STORES = LOCATIONS;
export const findLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
export const fullAddress = (l) => `${l.street}, ${l.city}, ${l.state} ${l.zip}`;
export const directionsUrl = (l) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${l.name}, ${fullAddress(l)}`)}`;
export const telHref = (phone) => `tel:+1${phone.replace(/\D/g, "")}`;

export const distanceMiles = ([lat1, lon1], [lat2, lon2]) => {
  const r = (x) => (x * Math.PI) / 180;
  const a = Math.sin(r(lat2 - lat1) / 2) ** 2 + Math.cos(r(lat1)) * Math.cos(r(lat2)) * Math.sin(r(lon2 - lon1) / 2) ** 2;
  return 3958.8 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
